import React, {Fragment} from 'react';
import {translate} from 'react-i18next';
import {MenuItem, Modal} from "react-bootstrap";
import ScheduleApi from "../../apis/ScheduleApi";
import {NotificationManager} from "react-notifications";
import {getSchedule} from "../../actions/scheduleAction";
import {connect} from "react-redux";

class ShiftImporter extends React.Component {

    state = {
        isOpen: false,
        loading: false,
        file: null
    };

    open = () => {
        this.setState({
            isOpen: true
        });
    };

    close = () => {
        this.setState({
            isOpen: false
        });
    };

    handleSubmit = (e) => {
        const { t, getSchedule } = this.props;
        e.preventDefault();
        this.setState({
            loading: true
        });
        ScheduleApi.importShifts(this.state.file)
            .then((response) => {
                this.setState({
                    loading: false
                });
                if(response.status === 200 && response.data.success && response.data.data.success) {
                    NotificationManager.success(t('schedule.shiftImporter.import.success'), t('default.notification.action.success'), 5000);
                    getSchedule();
                    this.close();
                } else {
                    NotificationManager.error(t('schedule.shiftImporter.import.error'), t('default.notification.action.error'), 5000);
                }
            })
            .catch((error) => {
                this.setState({
                    loading: false
                });
                NotificationManager.error(t('schedule.shiftImporter.import.error'), t('default.notification.action.error'), 5000);
            });
    };

    render() {
        const {t} = this.props;
        return (
            <Fragment>
                <MenuItem onClick={this.open}>
                    {t('schedule.buttons.importShifts')}
                </MenuItem>
                <Modal show={this.state.isOpen} onHide={this.close} dialogClassName="inmodal">
                    <Modal.Header closeButton>
                        <Modal.Title>{t('schedule.shiftImporter.title')}</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={this.handleSubmit}>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-xs-12">
                                    <label>
                                        {t('schedule.shiftImporter.file.label')}
                                    </label>
                                    <input type="file" className="form-control" value={this.file}
                                           onChange={(e) => this.setState({file: e.target.files[0]})}
                                           disabled={this.state.loading}/>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-default" onClick={this.close} type="button">
                                {t('default.cancel')}
                            </button>
                            <button className="btn btn-primary" type="submit" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                ) : null}
                                {t('default.import')}
                            </button>
                        </Modal.Footer>
                    </form>
                </Modal>
            </Fragment>
        )
    }
}

export default connect(null, { getSchedule })(translate()(ShiftImporter));
